const waitForImage = (imgElem) =>
  new Promise((resolve) =>
    imgElem.complete ? resolve() : (imgElem.onload = imgElem.onerror = resolve)
  );

const getPngFromSVG = async (
  svg: string,
  width: number,
  height: number,
  bgColor?: {
    x: number;
    y: number;
    width: number;
    height: number;
    color: string;
  },
  base64?: boolean = false
) => {
  const img = document.createElement('img');
  img.src = base64 ? svg : 'data:image/svg+xml;base64,' + window.btoa(svg);
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  await waitForImage(img);
  const ctx = canvas.getContext('2d');
  if (bgColor) {
    ctx.fillStyle = bgColor.color;
    ctx.fillRect(bgColor.x, bgColor.y, bgColor.width, bgColor.height);
  }
  ctx.drawImage(img, 0, 0, width, height);
  const png = '<img  src="' + canvas.toDataURL('image/png', 1.0) + '"/>';
  return png;
};

const downloadPngFromSVG = async (
  svg: string,
  width: number,
  height: number,
  bgColor?: {
    x: number;
    y: number;
    width: number;
    height: number;
    color: string;
  },
  base64?: boolean = false,
  filename?: string
) => {
  const img = document.createElement('img');
  img.src = base64 ? svg : 'data:image/svg+xml;base64,' + window.btoa(svg);
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  await waitForImage(img);
  const ctx = canvas.getContext('2d');
  if (bgColor) {
    ctx.fillStyle = bgColor.color;
    ctx.fillRect(bgColor.x, bgColor.y, bgColor.width, bgColor.height);
  }
  ctx.drawImage(img, 0, 0, width, height);

  var a = document.createElement('a');
  a.href = canvas.toDataURL('image/png', 1.0);
  a.download = filename || 'image.png';
  document.body.appendChild(a);
  a.click();
  setTimeout(function () {
    a.remove();
  }, 1000);
};

export default { getPngFromSVG, downloadPngFromSVG };
